import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import _ from 'lodash';

/**
 * Edit dropdown cell component
 * @module
 * @param {func} getProps - Get props function
 * @param {func} getColumns - Get columns function
 */
export function EditDropdownCell({ getProps, getColumns }) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        localizedData: [],
      }
    }

    componentDidMount() {
      const getedProps = getProps();
      let schema = getColumns().find(item =>
        item.field === this.props.field
      )

      if (getedProps.parentProps[schema['data']] && getedProps.parentProps[schema['data']].data?.length === 0) {
        getedProps.parentProps[schema['onChange']]({ filters: [] }, { skip: 0, take: 100 }, [], schema['primaryField'])
      }
    }

    handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field.split(".")[0],
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
      });
    }

    render() {
      const getedProps = getProps();
      const schema = getColumns().find(item =>
        item.field === this.props.field
      )

      const { dataItem, field } = this.props;
      let splitField = field.split(".")[0];
      const dataValue = _.get(dataItem, splitField);
      const data = getedProps.parentProps[schema['data']] ? getedProps.parentProps[schema['data']].data : [];

      const className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;
      const td =
        (
          <td colSpan={this.props.colSpan}
            className={className}
            style={this.props.style}
            role="gridcell"
            aria-colindex={(this.props.columnIndex || 0) - (this.props.level || 0) + 1}
            aria-selected={false}
            tabIndex="0"
          >
            {((dataItem.inEdit === true || dataItem.inEdit === splitField) && schema.editable !== false) ? (
              <DropDownList
                onChange={this.handleChange}
                value={dataValue && schema['primaryField'] !== undefined ? data?.find(c => c[schema['primaryField']] === dataValue[schema['primaryField']]) : ''}
                data={data ?? []}
                textField={schema['textField']}
              />
            ) : dataValue ? (
              dataValue[schema['textField']]
            ) : ''}
          </td>
        );

      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }
}


